import './page.css'
import Header from '../header/Header'
import Inner from '../inner/Inner.js'
import Footer from '../footer/Footer'

const Page = ({pageIndex, children, valuation_id, updateId, orientation="portrait", hidePage, isContentDynamic=true}) => {
    return (
    <div className={`page a4 ${orientation} ${hidePage?"page-hidden":""}`}>
        <Header valuation_id={valuation_id} updateId={updateId}/>
        <Inner content={children} isContentDynamic={isContentDynamic}/>
        <Footer pageIndex={pageIndex}/>
    </div>
    )
}

export default Page